/**
 * @description Gestion des fontions communes aux pages du site
 */

/* global bsBreakpoints */

(() => {
	// VARS
	const breakpoint = bsBreakpoints.detectBreakpoint();
	const share = document.querySelector('.share');
	const shareItems = document.querySelectorAll('.share');

	// FONCTIONS

	const wrapShareItems = () => {
		// Wrap les items dans une div
		Array.from(shareItems).forEach((el) => {
			const wrapper = document.createElement('div');
			wrapper.className = 'share__wrapper';
			el.parentNode.insertBefore(wrapper, el);
			wrapper.appendChild(el);
		});

		// Creation du bouton toggle
		const shareBtn = document.createElement('button');
		shareBtn.className = 'share__toggle btn btn-icon';
		// Ajout de l'attribut qui sert à gérer le toggle
		shareBtn.setAttribute('data-js-btn-toggle-all', '');
		// Placement de l'icon
		shareBtn.setAttribute('data-icon', 'share');
		// Ajout au wrap
		document.querySelector('.share__wrapper').appendChild(shareBtn);

		if (document.body.contains(document.querySelector('.share__toggle'))) {
			toggle();
		}
	};

	const unwrapShareItems = () => {
		if (document.body.contains(document.querySelector('.share__wrapper'))) {
			// Unwrap tous les éléments
			Array.from(shareItems).forEach((el) => {
				const elParentNode = el.parentNode;

				if (elParentNode !== document.body) {
					elParentNode.parentNode.insertBefore(el, elParentNode);
					elParentNode.parentNode.removeChild(elParentNode);
				}
			});

			// Suppression du btn toggle
			if (
				document.body.contains(
					document.querySelector('.share > button')
				)
			) {
				document.querySelector('.share__toggle').remove();
			}

			// Suppression classe active
			share.classList.remove('show');
		}
	};

	// Gestion de la classe active
	const toggle = () => {
		document
			.querySelector('.share__toggle')
			.addEventListener('click', function () {
				this.classList.toggle('active');
				share.classList.toggle('show');
			});
	};

	// Savoir quand la page est chargée
	const loaded = () => {
		document.addEventListener('DOMContentLoaded', () => {
			bsBreakpoints.init();

			if (breakpoint === 'xSmall' || breakpoint === 'small') {
				// If wrapper share n'existe pas alors go
				wrapShareItems();
			} else {
				// If wrapper existe alors on supprime
				unwrapShareItems();
			}
		});
	};

	// GO 🚀
	const init = () => {
		if (document.body.contains(share)) {
			loaded();

			// Resize
			window.addEventListener('resize', function (event) {
				const detectNewBreakpoint =
					bsBreakpoints.getCurrentBreakpoint();

				if (
					detectNewBreakpoint === 'xSmall' ||
					detectNewBreakpoint === 'small'
				) {
					if (
						document.body.contains(
							document.querySelector('.share__wrapper')
						)
					) {
						// unwrapShareItems();
					} else {
						wrapShareItems();
					}
				} else unwrapShareItems();
			});
		}
	};

	init();
})();
